import { Component, OnInit } from "@angular/core";
import { CommonService } from "../../../shared/common.service";

@Component({
  selector: "app-user-management",
  templateUrl: "./user-management.component.html",
  styleUrls: ["./user-management.component.css"],
})
export class UserManagementComponent implements OnInit {
  hasWritePermission: boolean = false;
  constructor(private commonService: CommonService) {}

  ngOnInit() {
    // const perm = this.commonService.getPermissions('users');
    // this.hasWritePermission = perm === 'W';
  }
}
